import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the beneficiaries screen — shares the View frame with the real content. */
export function BeneficiariesPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        <View.Body>
          <Skeleton variant="block" height={72} />
          <Skeleton variant="block" height={72} />
          <Skeleton variant="block" height={72} />
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
